// Source: src/components/AnnouncementBar.tsx. Values include intentional inline spacing.
const en = {
  "s1": "New",
  "s2": "Hardcharger™ is here: fast, secure, remote DuckDB 2.0",
  "s3": " — run it on GizmoData Cloud with $",
  "s4": " of free credit",
  "s5": "Dismiss announcement"
};
const pt: typeof en = {
  "s1": "Novidade",
  "s2": "Chegou o Hardcharger™: DuckDB 2.0 remoto, rápido e seguro",
  "s3": " — execute no GizmoData Cloud com US$ ",
  "s4": " de crédito grátis",
  "s5": "Fechar anúncio"
};
export default { en, 'pt-BR': pt };
